"use client";

import { useCallback, useMemo } from "react";
import { useRouter } from "next/navigation";
import { DirectPaths } from "@/config/routes";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { setRedirectTo } from "@/app/utils/helper";

export enum NavLoginEvent {
    GET_STARTED = "Get_Started",
    LOGIN = "Login",
    SIGNUP = "Signup",
}

/**
 * Pre/post-login redirects used by the site header (FD, bullion, global, default).
 */
export function useNavLogin() {
    const router = useRouter();

    const fdOrigin = useMemo(() => {
        const url = process.env.ICM_FD_POST_URL + DirectPaths.FD;
        const origin = url?.substring(0, url.indexOf("/", 8));
        return origin || "";
    }, []);

    const handleLogin = useCallback(
        (event: string) => {
            const isFD = window.location.href.includes(String(DirectPaths.FD_POSTFIX_PATH));
            const isBullion = window.location.href.includes(
                String(DirectPaths.BULLION_POSTFIX_PATH),
            );
            const isGlobal = window.location.href.includes(String(process.env.ICM_GLOBAL_URL));

            let redirectTo = "";

            if (event === NavLoginEvent.GET_STARTED || event === NavLoginEvent.LOGIN) {
                redirectTo = "/login";
            } else if (event === NavLoginEvent.SIGNUP) {
                redirectTo = "/signup";
            }

            const currentQueryString = window.location.search;
            const eventName = isFD ? `FD_Top_Nav_Bar_${event}` : `Top_Nav_Bar_${event}`;

            setAnalyticsEvent(window.location.origin, eventName);

            if (isFD) {
                setRedirectTo(`${fdOrigin + DirectPaths.FD_POSTFIX_PATH}${currentQueryString}`);
                window.location.href = `${fdOrigin + DirectPaths.FD + redirectTo}${currentQueryString}`;
            } else if (isBullion) {
                setRedirectTo(
                    `${process.env.ICM_BULLION_POST_URL + DirectPaths.BULLION_POSTFIX_PATH + DirectPaths.GOLD}${currentQueryString}`,
                );
                window.location.href = `${process.env.ICM_BULLION_POST_URL + DirectPaths.BULLION}${redirectTo}${currentQueryString}`;
            } else if (isGlobal) {
                setRedirectTo(
                    `${process.env.ICM_GLOBAL_POST_URL + DirectPaths.GLOBAL + DirectPaths.US_STOCKS}${currentQueryString}`,
                );
                window.location.href = `${process.env.ICM_GLOBAL_POST_URL}${redirectTo}${currentQueryString}`;
            } else {
                router.push(`${redirectTo}${currentQueryString}`);
            }
        },
        [fdOrigin, router],
    );

    return handleLogin;
}
